import { ArrowRight } from "lucide-react";
import { useSettings, getAffiliate } from "../lib/useSettings";

export function AffiliateBanner() {
  const settings = useSettings();
  return (
    <a href={getAffiliate(settings)} target="_blank" rel="noopener noreferrer" className="block bg-sky-700 text-white rounded-xl p-5 hover:bg-sky-800 transition-all" data-testid="affiliate-banner">
      <h4 className="font-bold text-sm mb-1" style={{ fontFamily: 'Outfit, sans-serif' }}>Ready to Compare Auto Insurance Rates?</h4>
      <p className="text-xs text-sky-200 mb-3">Free, no-obligation quotes from top providers.</p>
      <span className="bg-white text-sky-700 rounded-lg px-4 py-2 text-xs font-semibold inline-block">Get Free Quotes <ArrowRight size={12} className="inline ml-1" /></span>
    </a>
  );
}

export function AdSensePlaceholder({ size }) {
  const h = size === "large" ? "600px" : size === "banner" ? "100px" : "250px";
  return (
    <div className="bg-slate-100 border border-slate-200 rounded-xl p-4 text-center" style={{ minHeight: h }} data-testid="adsense-placeholder">
      <p className="text-[10px] text-slate-400 uppercase tracking-widest mb-2">Advertisement</p>
      <p className="text-sm text-slate-300">Google AdSense</p>
    </div>
  );
}

export function MoneyStrip() {
  const settings = useSettings();
  return (
    <div className="mt-8 mb-4 space-y-4">
      <a href={getAffiliate(settings)} target="_blank" rel="noopener noreferrer" className="block bg-sky-700 text-white rounded-xl p-5 hover:bg-sky-800 transition-all text-center" data-testid="money-strip-affiliate">
        <p className="font-bold text-sm mb-1">Ready to Compare Auto Insurance Rates?</p>
        <p className="text-xs text-sky-200 mb-3">Free, no-obligation quotes from top providers.</p>
        <span className="bg-white text-sky-700 rounded-lg px-4 py-2 text-xs font-semibold inline-block">Get Free Quotes <ArrowRight size={12} className="inline ml-1" /></span>
      </a>
      <div className="bg-slate-100 border border-slate-200 rounded-xl p-6 text-center" style={{ minHeight: "200px" }} data-testid="money-strip-adsense">
        <p className="text-[10px] text-slate-400 uppercase tracking-widest mb-2">Advertisement</p>
        <p className="text-sm text-slate-300">Google AdSense</p>
      </div>
    </div>
  );
}

export function AdSenseOnly() {
  return (
    <div className="mt-8 mb-4">
      <div className="bg-slate-100 border border-slate-200 rounded-xl p-6 text-center" style={{ minHeight: "200px" }} data-testid="adsense-only-mobile">
        <p className="text-[10px] text-slate-400 uppercase tracking-widest mb-2">Advertisement</p>
        <p className="text-sm text-slate-300">Google AdSense</p>
      </div>
    </div>
  );
}
